export const CONTACT_PHONE = '(877) 234-6196';
export const CONTACT_EMAIL = 'hmmm@nychbrands.com';
